import { SET_POPUP } from './actions';

var DefaultState = {
	activePopupData: []
}

export const popup = (state = DefaultState, action) => {
  	switch (action.type) {
	    case SET_POPUP:

	    	var newState = {activePopupData: action.data}
	    	if(typeof action.title !== 'undefined' && action.title) {
	    		newState.title = action.title;
	    	} else {
	    		newState.title = undefined;
	    	}

	      	return Object.assign({}, state, newState);
	    break;
	    default:
	    	return state;
      	//	return Object.assign({}, state, {activePopupData: []});
	}
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/popup/reducer.js